import Box from '@mui/material/Box';

export function LogoBox({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60px',
        width: '70px',
        borderRadius: '12px',
        backgroundColor: theme => theme.palette.background.antiflashWhite,
      }}
    >
      {children}
    </Box>
  );
}
